import { createSlice } from "@reduxjs/toolkit";
import { NumberNameLookupOutputDTO } from "../model/output/numberNameLookupRequestOutputDTO";
import * as CnamReducers from "../reducer/cnamReducers";

const numberNameSlice = createSlice({
  name: "cnam",
  initialState: initCnamState(),
  reducers: {
    ...CnamReducers,
  },
});

export interface NumberNameUpdateResponse {
  showModal: boolean;
  requestId: string;
  output: { tn: string; desiredCName: string }[];
  failedOutput: { tn: string; desiredCName: string; reason: string }[];
}

export interface NumberNameState {
  isLoading: boolean;
  cnamLookup: NumberNameLookupOutputDTO[];
  cnamUpdateResponse: NumberNameUpdateResponse;
}

function initCnamState(): NumberNameState {
  return {
    isLoading: false,
    cnamLookup: [],
    cnamUpdateResponse: {
      requestId: "",
      showModal: false,
      output: [],
      failedOutput: [],
    },
  };
}
const numberNameActions = numberNameSlice.actions;

export { numberNameActions, numberNameSlice };
